import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import _ from "underscore";
import { book } from "../../../lib/selectors/ReadingSelectors";

var TextTypes = require("lib/academic/TextTypes");
var CurrentUser = require("lib/account/CurrentUser");

var Modal = require('components/utility/AltModal');
var AddManualURLPick = require("components/reading/picks/AddManualURLPick");
var AddLibraryURLPick = require("components/reading/picks/AddLibraryURLPick");

var AddTitlePick = require("components/reading/picks/AddTitlePick");
var Glyphicon = require("components/utility/icons/Glyphicon");
var NewTaskCircle = require("components/utility/icons/NewTaskCircle")
var BookDisplay = require("components/reading/books/BookDisplay");
var Spinner = require("components/utility/Spinner");

var ParticipatingStudentsDisplay = require("components/reading/ParticipatingStudentsDisplay");
var AssignTaskModal = require("components/writing/tasks/AssignTaskModal");
var AssignTaskItemsModal = require("components/writing/tasks/AssignTaskItemsModal");

var AccountPlans = require("lib/account/AccountPlans");
var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var RosterActions = require("lib/actions/RosterActions");
var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var ActionUtility = require("lib/shared/ActionUtility");

require("reading/picks/picks_page.scss");

@connect(
	(state, props) => {
		var tasks = WritingSelectors.teacherPicksTasks({ state });

		var userIDsByTextID = WritingSelectors.userIDsByTaskSubjectID({
			state, conditions: { oneOfMatch: { subject_type: ["URLPick", "TitlePick"] } }
		})

		return {
			tasks: tasks,
			userIDsByTextID: userIDsByTextID,
			booksByURL: ReadingSelectors.assignedURLBooks({ state }),
			booksByTitle: ReadingSelectors.assignedTitleBooks({ state }),
		}
	},
	(dispatch, props) => ({
		populateData: () => {
			var fetchPlatforms = () => {
				return dispatch(ReadingActions.fetchLibraryPlatforms({ cache: true }));
			}
			var fetchTasks = () => {
				// TODO: standardize FE requests
				var conditions = { oneOfMatch: { subject_type: ["URLPick", "TitlePick"] } }
				var embeds = ['task.completion', 'task.task_item_ids']
				if (props.userIDs && $wr.isLargeRequest(props.userIDs)) {
					var conditions = { oneOfMatch: { subject_type: ["URLPick", "TitlePick"] } }
					var actionFunction = WritingActions.fetchTasks
					return new Promise(function (resolve, reject) {
						$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, { embeds }, (results) => {
							resolve(results)
						})
					}).catch(() => console.log("Tasks failed to load"))
				} else {
					return dispatch(WritingActions.fetchTasks({ conditions, embeds})).then((response) => {
						if (response) {
							var textIDs = _.uniq(_.pluck(_.values(response.tasks), "subject_id"));
						}

						if (textIDs && textIDs.length) {
							return dispatch(ReadingActions.fetchBooks({
								ids: textIDs,
								cache: true,
								query: { library_content: true }
							}))
						} else {
							return Promise.resolve();
						}
					});
				}
			}

			return Promise.all([fetchPlatforms(), fetchTasks()]);
		},

		fetchBooks: (textIDs) => {
			if (textIDs.length) {
				return Promise.all([
					dispatch(ReadingActions.fetchBooks({ ids: textIDs, query: { library_content: true } }))
				]);				
			} else {
				return Promise.resolve()
			}
		},

		clearTextTasks: (textID) => {
			return dispatch(WritingActions.deleteManyTasks({
				filters: { subject_id: textID },
				conditions: {
					oneOfMatch: { subject_type: ["URLPick", "TitlePick"] }
				}
			}));
		},
		// used to refresh task items after assignment
		fetchTasks: () => {
			dispatch(ActionUtility.clearLoadingRecords("tasks"))
			if ($wr.isLargeRequest(props.userIDs)) {
				var conditions = { oneOfMatch: { subject_type: ["URLPick", "TitlePick"] } }
				var actionFunction = WritingActions.fetchTasks
				return new Promise(function (resolve, reject) {
					$wr.handleLargeRequest(dispatch, userIDs, conditions, actionFunction, {}, (results) => {
						resolve(results)
					})
				}).catch(() => console.log("Tasks failed to load"))
			} else {
				return dispatch(WritingActions.fetchTasks({
					conditions: {
						oneOfMatch: { subject_type: ["URLPick", "TitlePick"] }
					},
				}))
			}
		},
	}),
)

@providePopulateData({ waitForLoad: true })
class PicksPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("PicksPage");

		this.urlLibraryPickModal = React.createRef();
		this.titlePickModal = React.createRef();
		this.urlManualPickModal = React.createRef();
		this.assignTaskModal = React.createRef();
		this.assignTaskItemsModal = React.createRef();

		this.state = {
			textToAssign: null,
			selectedUserIDs: [],
			taskItemsEntered: false,
			loading: false 
		}
	}
	// paywall helper method
	allowAccess() {
		var user = CurrentUser.get();
		var activeTrials = user.account.active_trials
		var hasQualifiedTrial = activeTrials && (activeTrials[AccountPlans.PRODUCTS.WR_GOLD] || activeTrials[AccountPlans.PRODUCTS.WR_SILVER]) ? true : false
		return (user.product === "wrSilver" || user.product === "wrGold" || hasQualifiedTrial) ? true : false
	}

	unssign(textID) {
		if (confirm("Are you sure you want to delete this?")) {
			this.props.clearTextTasks(textID);
		}
	}

	toggleAssign(text, edit) {
		// Book may not yet be in redux (or have library content)
		this.props.fetchBooks([text.text_id]);

		this.setState({ textToAssign: text }, () => {
			this.titlePickModal.current.hide();
			this.assignTaskModal.current.show();
		});
	}

	isFinishedStudent(studentID) {
		var task = this.findTask(studentID)
		return task.completion
	}

	calculateFinishedStudents(tasks, bookId) {
		return _.size(_.where(tasks, { completion: true }))
	}

	renderTitlePickModal() {
		return (
			<Modal headerText="Add Title" ref={ this.titlePickModal }>
				<AddTitlePick toggleAssign={ this.toggleAssign } />
			</Modal>
		);
	}

	renderLibraryURLPickModal() {
		return (
			<Modal headerText="Discover" className="wideModal"
				ref={ this.urlLibraryPickModal }>
				<AddLibraryURLPick toggleAssign={ this.toggleAssign } />
			</Modal>
		);
	}

	renderManualURLPickModal() {
		return (
			<Modal headerText="Add URL" ref={ this.urlManualPickModal }>
				<AddManualURLPick toggleAssign={ this.toggleAssign } />
			</Modal>
		);
	}

	renderAssignedByTitle() {
		return _.sortBy(this.props.booksByTitle, "title").map((book) => {
			var studentIDs = this.props.userIDsByTextID[book.text_id];
			var finishedCount = this.allowAccess() ? 'No activities assigned' : ''
			var tasks = _.where(this.props.tasks, { subject_id: book.text_id, subject_type: 'TitlePick' })
			if (tasks.length && _.size(_.first(tasks).task_item_ids)) {
				finishedCount = `${this.calculateFinishedStudents(tasks, book.text_id)} out of ${studentIDs.length} have completed all activities`
			}

			return (
				<div className="assignedText" key={ book.text_id }>
					<BookDisplay textID={ book.text_id } coverWidth={ 75 }
						showAuthor showCover showLibraryTags>

						<ParticipatingStudentsDisplay studentIDs={ studentIDs }
							maxDisplayStudentCount={ 3 } />

						<a href="#" className="editTaskAssignment"
							onClick={ (e) => { $wr.nope(e); this.toggleAssign(book) } }>
							Edit
						</a><br/>
						<span className="statSummary">
							{finishedCount}
						</span>
					</BookDisplay>

					<a href="#" className="removeLink"
						onClick={ (e) => { $wr.nope(e); this.unssign(book.text_id) } }>
						<Glyphicon icon="remove" />
					</a>
				</div>
			);
		})
	}

	renderAssignedByURL() {
		if (this.state.loading) {
			return <Spinner placeholder={true} scale={1.7} />
		} else {
			return _.sortBy(this.props.booksByURL, "title").map((book) => {
				var studentIDs = this.props.userIDsByTextID[book.text_id];
				var finishedCount = this.allowAccess() ? 'No assignments' : ''
				var tasks = _.where(this.props.tasks, { subject_id: book.text_id, subject_type: 'URLPick' })
				if (tasks.length && _.size(_.first(tasks).task_item_ids)) {
					finishedCount = `${this.calculateFinishedStudents(tasks, book.text_id)} out of ${studentIDs.length} have completed all activities`
				}

				return (
					<div className="assignedText" key={book.text_id}>
						<BookDisplay textID={book.text_id} linkURL showLibraryTags
							showCover coverWidth={100}>

							<ParticipatingStudentsDisplay studentIDs={studentIDs}
								maxDisplayStudentCount={3} />

							<a href="#" className="editTaskAssignment"
								onClick={(e) => { $wr.nope(e); this.toggleAssign(book) }}>
								Edit
							</a><br />
							<span className="statSummary">
								{finishedCount}
							</span>
						</BookDisplay>

						<a href="#" className="removeLink"
							onClick={(e) => { $wr.nope(e); this.unssign(book.text_id) }}>
							<Glyphicon icon="remove" />
						</a>
					</div>
				);
			})

		}
	}

	renderAssignTaskModal() {
		if (!this.state.textToAssign) {
			return;
		}

		if (this.state.textToAssign.url) {
			var modalHeader = "Assign URL to:";
			var subjectType = "URLPick";
		} else {
			var modalHeader = "Assign Title to:";
			var subjectType = "TitlePick";
		}

		var renderAdditionalModal = this.allowAccess() ? true : false

		return (
			<Modal ref={ this.assignTaskModal } headerText={ modalHeader }
				modalOrder={ 2 }>

				<AssignTaskModal
					textToAssign={this.state.textToAssign}
					renderAdditionalModal={renderAdditionalModal}
					taskSubjectType={ subjectType }
					taskSubjectID={ this.state.textToAssign.text_id }
					selectedActivityTitle={ this.state.textToAssign.title }
					onAssign={ this.hideAssignModal } />
			</Modal>
		)
	}

	hideAssignModal(selectedUserIDs, showNextModal) {
		this.setState({ selectedUserIDs: selectedUserIDs })
		this.assignTaskModal.current.hide();
		if (showNextModal) {
			this.setState({ taskItemsEntered: false })
			this.assignTaskItemsModal.current.show();
		}
	}

	renderAssignTaskItemsModal() {
		if (!this.state.textToAssign) {
			return;
		}

		var modalHeader = "Assign Activity Items:";
		if (this.state.textToAssign.url) {
			var subjectType = "URLPick";
		} else {
			var subjectType = "TitlePick";
		}

		return (
			<Modal ref={this.assignTaskItemsModal} headerText={modalHeader} modalOrder={3}>
				<AssignTaskItemsModal
					selectedUserIDs={this.state.selectedUserIDs}
					taskSubjectType={subjectType}
					taskSubjectID={this.state.textToAssign.text_id}
					selectedActivityTitle={this.state.textToAssign.title}
					onAssign={this.hideTaskItemAssignmentModal} />
			</Modal>
		)
	}

	hideTaskItemAssignmentModal() {
		this.assignTaskItemsModal.current.hide();
		this.props.fetchTasks();
	}

	onAssignTitleAsHide() {
		this.setState({ textToAssign: null });
	}

	render() {
		var header = '';
		if (!this.props.hideTitle) {
			header = (
				<header className="pageHeader">
					<h1>Teacher Picks</h1>
				</header>
			)
		}

		var assignTaskModal = this.renderAssignTaskModal();
		var assignTaskItemsModal = this.renderAssignTaskItemsModal()

		return (
			<div className="container picksPage">
				{ header }

				<div className="row">
					<div className="col-md-6">
						<h3 className="pickHeader normal">
							Assign Offline Reading
						</h3>

						<p className="assignInstructions">
							Assign physical books for students to read offline before getting back on Whooo’s Reading to answer questions.
						</p>

						<div className="byTitle">
							{ this.renderAssignedByTitle() }
						</div>

						<div>
							<button className="addPick" onClick={ () => this.titlePickModal.current.show() }>
								<NewTaskCircle />
								Add Title
							</button>
						</div>
					</div>
					<div className="col-md-6">
						<h3 className="pickHeader normal">
							Assign Online Reading (By URL)
						</h3>

						<p className="assignInstructions">
							Assign online articles and books for students to read via Whooo’s Reading and then return to answer questions.
						</p>

						<div className="byURL">
							{ this.renderAssignedByURL() }
						</div>

						<div>
							<button className="addPick" onClick={ () => this.urlLibraryPickModal.current.show() }>
								<NewTaskCircle /> Discover
							</button>

							<button className="addPick" onClick={ () => this.urlManualPickModal.current.show() }>
								<NewTaskCircle /> Add URL
							</button>
						</div>
					</div>
				</div>

				{ this.renderTitlePickModal() }
				{ this.renderLibraryURLPickModal() }
				{ this.renderManualURLPickModal() }
				{ assignTaskModal}
				{ assignTaskItemsModal }
			</div>
		)
	}

	pullOrRefreshBooks() {
		var textIDs = _.uniq(_.pluck(_.values(this.props.tasks), "subject_id"));
		this.props.fetchBooks(textIDs).then(() => this.setState({ loading: false }));
	}

	componentDidUpdate(prevProps) {
		if ($wr.isLargeRequest(this.props.userIDs) && _.size(this.props.tasks) !== _.size(prevProps.tasks)) {
			if (_.size(prevProps.tasks) == 0) {
				this.setState({ loading: true })
			}

			this.pullOrRefreshBooks()
		}
	}

	componentDidMount() {
		this.pullOrRefreshBooks()
	}
};

PicksPage.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from @connect
	tasks: PropTypes.array,
	booksByURL: PropTypes.array,
	booksByTitle: PropTypes.array,
	userIDsByTextID: PropTypes.object,
	totalStudentCount: PropTypes.number,
	userIDs: PropTypes.array,

	// Handlers from @connect
	fetchBooks: PropTypes.func.isRequired,
	populateData: PropTypes.func.isRequired,
	clearTextTasks: PropTypes.func.isRequired,
	fetchTasks: PropTypes.func,

	// From Activities page
	hideTitle: PropTypes.bool
});

module.exports = PicksPage;



// WEBPACK FOOTER //
// ./modules/components/reading/picks/PicksPage.js